/**
 *
 * Filter
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import withResize from 'components/ResizeContainer';
import _isEmpty from 'lodash/isEmpty';
import _flatten from 'lodash/flatten';
import _uniqBy from 'lodash/uniqBy';
import _get from 'lodash/get';
import Hidden from '@material-ui/core/Hidden';
import { makeSelectFilterTopics } from 'containers/Topics/selectors';
import { getResourcesCountByTopic } from 'containers/Main/actions';
import {
  makeSelectThemes,
  makeSelectResourcesCountByTopic,
} from 'containers/Main/selectors';
import { makeSelectProcessing } from 'containers/Sources/selectors';
import { getTopics } from 'containers/Topics/actions';
import { withRouter } from 'react-router';
import MixPanel from 'utils/mixpanelService';
import withSizes from 'react-sizes';
import qs from 'qs';
import { MEDIA_TYPES, typesIcons } from './constants';
import MobileScroll from './MobileScroll';
import DesktopScroll from './DesktopScroll';
import FilterContext from './FilterContext';

/* eslint-disable */

class Filter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedTopic: '',
      selectedTopicSlug: '',
      selectedMediaType: 'All Media Types',
      mediaTypes: MEDIA_TYPES,
      isSearching: false,
      topicsList: this.getTopicsList(),
      filteredTopicsList: [],
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.resourcesByTopic !== prevProps.resourcesByTopic) {
      this.assembleResourcesTypes(this.props.resourcesByTopic);
    }
    if(this.props.themes !== prevProps.themes) {
      this.setState({
        topicsList: this.getTopicsList(this.props),
      });
    }
  }

  assembleResourcesTypes = (types) => {
    let arrMediaTypes = [{...MEDIA_TYPES[0]}];
    types.forEach(({value, count}) => {
      if (count > 0) {
        arrMediaTypes.push({
          label: value,
          value,
          icons: typesIcons[value]
        })
      }
    })
    this.setState({mediaTypes: arrMediaTypes})
  }

  getTopicsList = (props) => {
    const lists = [];
    const { themes } = props || this.props;
    if(_isEmpty(themes)) return null;
    themes.forEach(theme => {
      lists.push([...new Set([].concat([..._get(theme, 'topicsCollection.items')]))]);
    });
    const flattenArrs = _flatten(lists);
    return  _uniqBy(flattenArrs, 'slug' );
    
  }
  searchTopic = ({target: { value }}) => {
    this.setState({isSearching: !!value, selectedTopic: value});
    this.filterTopicsList(value);
  }

  filterTopicsList = (value) => {
    let filteredTopicsList = this.state.topicsList;
    filteredTopicsList = filteredTopicsList.filter(({ title, reviewStatus }) => reviewStatus === 'Accepted' && title.toLowerCase().search(value.toLowerCase()) !== -1 );
    this.setState({filteredTopicsList});
  }

  changeFilter = (slug, { target: { value } } = {}, type, topicId) => {
    if (type === 'selectedTopic') {
      this.setState({selectedTopicSlug : slug});
      this.props.getResourcesCountByTopic(value)
    }
    this.setState({
      [type]: value,
    });
  };

  go = () => {
    const { selectedMediaType, selectedTopic, mediaTypes, selectedTopicSlug } = this.state
    let typesFilter = `types=${selectedMediaType}`;
    if (selectedMediaType === 'All Media Types') {
      const types = mediaTypes
        .filter(type => !['All Media Types', 'People'].includes(type.value))
        .map(item => item.value);
      typesFilter = qs.stringify({ types });
    }

    MixPanel.track('Help Me With', {
      type: selectedMediaType,
      topic: selectedTopic,
      path: window.location.pathname,
      name: selectedTopic,
    });

    this.props.history.push(`/topics/${selectedTopicSlug}?${typesFilter}`);
  };

  render() {
    const {themes, clientDetails, isLanding, bg } = this.props;
    const { selectedTopic, selectedMediaType, mediaTypes, selectedTopicSlug, filteredTopicsList, isSearching } = this.state;
    if (_isEmpty(themes)) return null;
    const variantOptions = {
      selectedTopic,
      changeFilter: this.changeFilter,
      mediaTypes,
      selectedMediaType,
      go: this.go,
      themes,
      searchTopic: this.searchTopic,
      selectedTopicSlug,
      isSearching,
      filteredTopicsList,
      clientDetails,
      isLanding,
      bg,
    };
    return (
      <FilterContext.Provider
      value={variantOptions}
    >
        <Hidden xsDown>
          <DesktopScroll/>
        </Hidden>
        <Hidden smUp>
          <MobileScroll {...variantOptions} />
        </Hidden>
      </FilterContext.Provider>
    );
  }
}

Filter.propTypes = {
  popularTopics: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  location: PropTypes.object,
  processing: PropTypes.bool,
  section: PropTypes.string,
  defaultTopic: PropTypes.string,
  isMobile: PropTypes.bool,
  data: PropTypes.object,
  clientData: PropTypes.object,
  themes: PropTypes.array,
  getResourcesCountByTopic: PropTypes.func,
  resourcesByTopic: PropTypes.array,
  isLanding: PropTypes.bool,
  bg: PropTypes.string,
};

Filter.defaultProps = {
  isLanding: false,
};

const mapStateToProps = createStructuredSelector({
  popularTopics: makeSelectFilterTopics(),
  processing: makeSelectProcessing(),
  themes: makeSelectThemes(),
  resourcesByTopic: makeSelectResourcesCountByTopic(),
});

function mapDispatchToProps(dispatch) {
  return {
    getTopics: payload => dispatch(getTopics(payload)),
    getResourcesCountByTopic: payload => dispatch(getResourcesCountByTopic(payload))
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 600,
});

export default compose(
  withResize,
  withConnect,
  withRouter,
  withSizes(mapSizesToProps),
)(Filter);
